/**
 * Fetch data for a single vault from vaults.fyi
 * @param {string} address - Vault address
 * @param {string} apiKey - Your vaults.fyi API key
 * @param {string} network - "mainnet" or "base"
 * @returns {Object} Vault data JSON
 */
async function fetchVaultData(address, apiKey, network = "mainnet") {
  const url = `https://api.vaults.fyi/v1/vaults/${network}/${address}`;
  const resp = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "x-api-key": apiKey,
    },
  });
  if (!resp.ok) {
    throw new Error(
      `Vault fetch error for ${address} on ${network}: ${resp.status} ${resp.statusText}`
    );
  }
  return resp.json();
}

/**
 * Fetch data for multiple vault addresses in parallel
 * @param {Array} vaultAddresses - Array of vault address objects: [{address, label}, ...]
 * @param {string} apiKey - vaults.fyi API key
 * @param {string} network - "mainnet" or "base"
 * @returns {Array} Array of vault data, each augmented with .label from the input
 */
export async function fetchAllVaults(
  vaultAddresses,
  apiKey,
  network = "mainnet"
) {
  if (!vaultAddresses || vaultAddresses.length === 0) {
    return [];
  }
  const promises = vaultAddresses.map((v) =>
    fetchVaultData(v.address, apiKey, network)
  );
  const results = await Promise.all(promises);

  // Attach label from the original array
  const combined = results.map((vaultResult, idx) => ({
    ...vaultResult,
    label: vaultAddresses[idx].label,
  }));

  return combined;
}
